import { AnuncioExterno } from "./AnuncioExterno";
import { Domicilio } from "./Domicilio";

interface _FileDocument {
    id: number,
    tipo_archivo: string,
    filename: string,
    fullpath: string,
    mime_type: string,
    url: string
}

class FileDocument implements _FileDocument {
    id: number = 0;
    tipo_archivo: string = '';
    filename: string = '';
    fullpath: string = '';
    mime_type: string = '';
    url: string = '';

    constructor() {
        this.id = 0;
        this.tipo_archivo = '';
        this.filename = '';
        this.fullpath = '';
        this.mime_type = '';
        this.url = '';
    }
}

interface SeccionEspectacular {
    solicitud_espectacular_id: number,
    largo: number,
    ancho: number,
}

interface _Espectacular {
    id: number,
    folio: string,
    clave_catastral: string,
    no_folio: boolean,
    contribuyente_id: number,
    tipo_anuncio_id: number,
    altura_mts: string,
    ubicacion_id: number,
    ubicacion: Domicilio | null,
    vistas: number,
    croquis_ubicacion: string | null,
    croquis_ubicacion_file: FileDocument | null,
    secciones: SeccionEspectacular[],
    colindansia_norte: string | null,
    colindansia_norte_file: FileDocument,
    colindansia_sur: string | null,
    colindansia_sur_file: FileDocument,
    referencias: string | null,    
    solventacion_acta_inspeccion: string | null,
    solventacion_acta_inspeccion_file: FileDocument,
    certificado_ubicacion: string | null,
    certificado_ubicacion_file: FileDocument,    
    poliza_seguro: string | null,
    poliza_seguro_file: FileDocument,
    luminosidad: string | null,
    luminosidad_file: FileDocument,
    documentos: {
        colindansia_norte: {
            file: any,
            data: any
        },
        colindansia_sur: {
            file: any,
            data: any
        },
        croquis_ubicacion: {
            file: any,
            data: any
        }
        solventacion_acta_inspeccion: {
            file: any,
            data: any
        },
        certificado_ubicacion: {
            file: any,
            data: any
        },
        poliza_seguro: {
            file: any,
            data: any
        },
        luminosidad: {
            file: any,
            data: any
        },
        constancia_uso_suelo: {
            file: any,
            data: any
        },
        permiso_anuncio: {
            file: any,
            data: any
        },
        contrato_arrendamiento: {
            file: any,
            data: any
        }
    },
    images: any,
    estatus_revision: number,
    motivo_rechazo: string | null,
    documento_firmado: boolean,
    fecha_firma: string | null,
    constancia_uso_suelo_exist:  any
    edo_cuenta_status: any,
    constancia_uso_suelo_file: FileDocument,
    permiso_anuncio_externo: AnuncioExterno | null,
    permiso_anuncio: string | null,
    permiso_anuncio_file: FileDocument,
    contrato_arrendamiento_file: FileDocument,
    tipo_propiedad_id: number
}

class Espectacular implements _Espectacular {
    id: number = 0;
    folio: string = "";
    clave_catastral: string = "";
    no_folio: boolean = false;
    contribuyente_id: number = 0;
    tipo_anuncio_id: number = 0;
    ubicacion_id: number = 0;
    ubicacion = new Domicilio();
    vistas: number = 0;
    croquis_ubicacion: string = "";
    croquis_ubicacion_file: FileDocument = new FileDocument();
    secciones: SeccionEspectacular[] = [];
    colindansia_norte: string = "";
    colindansia_norte_file: FileDocument = new FileDocument();    
    colindansia_sur: string = "";
    colindansia_sur_file: FileDocument = new FileDocument();
    altura_mts: string = "";
    referencias: string = "";   
    solventacion_acta_inspeccion: string = "";
    solventacion_acta_inspeccion_file: FileDocument = new FileDocument();
    certificado_ubicacion: string = "";
    certificado_ubicacion_file: FileDocument = new FileDocument();
    poliza_seguro: string = "";
    poliza_seguro_file: FileDocument = new FileDocument();
    luminosidad: string = "";
    luminosidad_file: FileDocument = new FileDocument();
    documentos: any = {
        colindansia_norte: {
            file: null as any,
            data: {} as any
        },
        colindansia_sur: {
            file: null as any,
            data: {} as any
        },
        croquis_ubicacion: {
            file: null as any,
            data: {} as any
        },
        solventacion_acta_inspeccion: {
            file: null as any,
            data: {} as any
        },
        certificado_ubicacion: {
            file: null as any,
            data: {} as any
        },
        poliza_seguro: {
            file: null as any,
            data: {} as any
        },
        luminosidad: {
            file: null as any,
            data: {} as any
        },
        constancia_uso_suelo: {
            file: null as any,
            data: {} as any
        },
        permiso_anuncio: {
            file: null as any,
            data: {} as any
        },
        contrato_arrendamiento: {
            file: null as any,
            data: {} as any
        }
    };
    images: any;
    constancia_uso_suelo_file: FileDocument = new FileDocument();
    estatus_revision: number = 1;
    motivo_rechazo: string | null = null;
    documento_firmado: boolean = false;
    fecha_firma: string | null = null;
    constancia_uso_suelo_exist: any;
    edo_cuenta_status: any;
    permiso_anuncio_externo: AnuncioExterno | null = null;
    permiso_anuncio: string | null = null;
    permiso_anuncio_file: FileDocument = new FileDocument();
    contrato_arrendamiento_file: FileDocument = new FileDocument();
    tipo_propiedad_id: number = 0;
    
}

export { Espectacular, _Espectacular, FileDocument, SeccionEspectacular };